import { FavoriteWorkoutsDoc } from '@sworkit/api';
import { arrayRemove, arrayUnion, doc, onSnapshot, setDoc } from 'firebase/firestore';
import { fst as firestore } from './firebase';
import { getLoggedInUserId } from './firestore-user';

export function firestoreFavoritesListener(
  callback: (favorites: FavoriteWorkoutsDoc['workouts']) => void
) {
  const uid = getLoggedInUserId();
  if (!uid || !firestore) return;
  const q = doc(firestore, `users/${uid}/collections/favorites`)
  return onSnapshot(q, async (snap) => {
    let workoutSlugs: FavoriteWorkoutsDoc['workouts'] = [];
    if (snap.exists) {
      const favoritesDoc = snap.data() as FavoriteWorkoutsDoc;
      workoutSlugs = favoritesDoc?.workouts || [];
    }
    callback(workoutSlugs);
  });
}

export function updateFavorite(
  favoriteWorkout: FavoriteWorkoutsDoc['workouts'][0],
  favorite: boolean
) {
  const uid = getLoggedInUserId();
  if (!uid || !firestore) return;
  const ref = doc(firestore, `users/${uid}/collections/favorites`);
  const update: Partial<FavoriteWorkoutsDoc> = {
    workouts: favorite
      ? (arrayUnion(favoriteWorkout) as any)
      : (arrayRemove(favoriteWorkout) as any),
  };
  setDoc(ref, update, { merge: true });
}

export function setFavorites(favorites: string[]) {
  const uid = getLoggedInUserId();
  if (!uid || !firestore) return;
  const ref = doc(firestore, `users/${uid}/collections/favorites`);
  const update: Partial<FavoriteWorkoutsDoc> = {
    workouts: favorites.map((favorite) => {
      return { slug: favorite };
    }),
  };
  return setDoc(ref, update, { merge: true });
}

export function isFavorite(
  workoutSlug: string,
  favorites: FavoriteWorkoutsDoc['workouts']
) {
  if (!favorites) return undefined;
  const found = favorites.find((workout) => workout.slug === workoutSlug);
  return found ? true : false;
}
